// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentCardWrapper_wrapper__i0GK7"};